import { getAllEntitiesAtPath } from 'app/infrastructure/store';
import { tableName } from 'app/area/case/case-data-model';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { CaseState } from 'app/area/case/types-store';
import { InitialUiEngineProps } from 'app/infrastructure/ui/types-uischema';

interface ConnectedCaseIdsProps extends InitialUiEngineProps {
  connectionTypeId?: number;
}

export const connectedCasesIds = (caseState: CaseState, uiEngineProps: ConnectedCaseIdsProps) => {
  const connectionTypeId = uiEngineProps.connectionTypeId || 
                           uiEngineProps.componentDescriptor.properties.connectionTypeId;

  return {
    connectedCasesIds: 
      getAllEntitiesAtPath(
        getCaseData(caseState, uiEngineProps), 
        [tableName.trans, tableName.connectionTypes, tableName.connectedCases]
      )
      .filter(e => e.id.some(i => i[tableName.connectionTypes] === connectionTypeId))
      .map(e => e.primaryKey.value)
  };
};

export const connectedCasesIdsIrrespectiveOfConnectionType = (caseState: CaseState, uiEngineProps: ConnectedCaseIdsProps) => {
  return {
    connectedCasesIds: 
      getAllEntitiesAtPath(
        getCaseData(caseState, uiEngineProps), 
        [tableName.trans, tableName.connectedCasesSummary]
      )
      .map(e => e.primaryKey.value)
  };
};

export const connectedCasesIdsByConnectionType = (caseState: CaseState, uiEngineProps: ConnectedCaseIdsProps) => {

  const allConnectedCases = getAllEntitiesAtPath(
    getCaseData(caseState, uiEngineProps),
    [tableName.trans, tableName.connectionTypes, tableName.connectedCases]
  );
  const results = allConnectedCases.reduce((result, e) => {
    const connectionType = e.id.find(i => i[tableName.connectionTypes]);
    if (connectionType) {
      const key = connectionType[tableName.connectionTypes];
      result[key] = result[key] || [];
      result[key].push(e.primaryKey.value);
    }
    return result;
  }, {});

  return {
    connectedCasesIdsByConnectionType: results
  };
};

export interface ConnectedCasesIdsShape {
  connectedCasesIds: any;
}
